import { InvoiceTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1950. 請求タスクコメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const invoiceTaskComments = (props: Props): Promise<InvoiceTaskComment[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_comments`
  );
};

export const useInvoiceTaskComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => invoiceTaskComments(props),
  });
};

export const useInvoiceTaskCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'sales_orders',
    props.sales_order_id,
    'invoice_tasks',
    props.task_id,
    'invoice_task_comments',
  ];
};
